import getCommandBarButtonsForMail from './getCommandBarButtonsForMail';
import getShareByEmailButton from './getShareByEmailButton';
import { SxSStore } from 'owa-sxs-store';
import { PreviewPaneCommandBarItem } from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';

export default function getCommandBarButtonsForGroupFilesHub(
    sxsStore: SxSStore
): PreviewPaneCommandBarItem[] {
    const commandBarButtonsForMail = getCommandBarButtonsForMail(sxsStore);

    return [...commandBarButtonsForMail, getShareByEmailButton(sxsStore)];
}
